import { useState, useEffect, useRef } from "react";
import { Button, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAuth as useOidcAuth } from "react-oidc-context";

import "./styles.scss";
import {
  triggerLogout,
} from "core/authentication";
import {
  localStorageCache,
  sessionStorageCache
} from "core/store";
import { loginService } from "services";
import { appInsights } from "services/app-insight/app-insight";

import Logo from "../../assets/images/logo.svg";
import ArrowDown from "../../assets/images/arrow-down.svg";
import LanguageSelector from "components/LanguageSelector";
import { useSession } from "shared/hooks/useSession";
import HeaderOptions from "components/HeaderOptions";
import Report from "components/Reports";
import ModalPopup from "components/ModalPopup";
import { IoIosInformationCircle } from "react-icons/io";

const DISCLAIMER_KEY = "disclaimerAccepted";
const Header = ({ className = "" }) => {
  const auth = useOidcAuth();
  const { logoutSession, endSessionConversation } = useSession();
  const [logoutClass, setLogoutClass] = useState("");
  const [showReport, setShowReport] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const response = await loginService.validateUser();
        setIsAdmin(response);
      } catch {
        setIsAdmin(false);
      }
    };

    checkAdmin();
  }, []);


  useEffect(() => {
    const accepted = localStorage.getItem(DISCLAIMER_KEY);
    if (!accepted) {
      setTimeout(() => {
        setShowDisclaimer(true);
      }, 500);
    }
  }, []);

  const handleAcceptDisclaimer = () => {
    localStorage.setItem(DISCLAIMER_KEY, "true");
    setShowDisclaimer(false);
  };

  const logout = async () => {
    await endSessionConversation();
    await logoutSession();
    await auth.removeUser();
    auth.stopSilentRenew?.();
    appInsights.trackEvent({ name: "The user manually logged out" });
    localStorageCache.clear();
    sessionStorageCache.clear();
    loginService.clearLoginData();
    await auth.signoutRedirect();
    triggerLogout();
  };


  return (
    <>
      <div className={`${className} header-wrapper`}>
        <div className="header-rect" />
        <header className="container-fluid px-lg-4">
          <Navbar expand="lg" className="position-relative p-0 px-lg-2">
            <div className="d-flex justify-content-between w-100">
              <div className="d-flex left align-items-center">
                <Navbar.Brand
                  as={Link}
                  to={"/"}
                  className="align-items-center d-none d-lg-block"
                >
                  <img
                    src={Logo}
                    style={{ height: "2rem", zIndex: "500" }}
                    alt="NYC public school logo"
                  />
                </Navbar.Brand>
              </div>
              <LanguageSelector onLangSelectorShowToggle={(show) => show ? setLogoutClass("show") : setLogoutClass("")} />
              <div className={`d-flex right align-items-center justify-content-end gap-2 logout-btn-wrapper ${logoutClass}`}>
                {/* <span className="name-text d-md-block d-none">{auth.user?.profile?.given_name}</span> */}
                {/* <div onClick={logout} role="button" className="d-flex flex-column position-relative">
                  <Button variant="" className="rounded-5">
                    <img
                      src={ArrowDown}
                      alt=""
                    />
                  </Button>
                  <div className="position-absolute logout-text">Logout</div>
                </div> */}
                <HeaderOptions user={auth.user?.profile} logout={logout} setShowReport={setShowReport} isAdmin={isAdmin} />
              </div>
            </div>
          </Navbar>
          {showReport && <Report setShowReport={setShowReport} />}
        </header>
      </div>
      <ModalPopup
        show={showDisclaimer}
        heading={
          <div className="d-flex align-items-center gap-2">
            <IoIosInformationCircle
              className="text-primary"
              style={{ fontSize: "2rem" }}
            />
            <span className="bold">Note</span>
          </div>
        }
        description="This application relies on machine translation."
        buttons={
          <button
            className="btn btn-primary"
            onClick={handleAcceptDisclaimer}
          >
            OK
          </button>
        }
        onClose={() => setShowDisclaimer(false)}
      />
    </>
  );
};

export default Header;
